import { Box, Grid, Paper } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import {
  PreviewCustomerOrderQuery,
  PreviewDomesticPageOrderQuery
} from "@saleor/graphql";
import { maybe } from "@saleor/misc";
import { formatDate } from "@saleor/utils/date";
import classNames from "classnames";
import React, { FC } from "react";
import { useIntl } from "react-intl";

import useStyle from "./styles";
type PreviewCustomerOrderQueryTmp = PreviewCustomerOrderQuery["previewCustomerOrder"];
interface PreviewCustomerOrder extends PreviewCustomerOrderQueryTmp {
  poDate?: string;
}
export interface PreviewHeaderProps {
  previewOrder?:
    | PreviewCustomerOrder
    | PreviewDomesticPageOrderQuery["previewDomesticPageOrder"];
}

const PreviewOrderHeader: FC<PreviewHeaderProps> = ({ previewOrder }) => {
  const classes = useStyle();
  const intl = useIntl();

  return (
    <Paper className={classes.header}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Box className={classes.headerItem}>
            <MyTypography
              variant="subtitle3"
              className={classNames(classes.headerTitle, classes.center)}
            >
              {intl.formatMessage({
                defaultMessage: "เลขที่ใบสั่งซื้อ"
              })}
            </MyTypography>
            <MyTypography variant="subtitle1" className={classes.mainColor}>
              {previewOrder?.soNo}
            </MyTypography>
          </Box>
          <Box className={classes.headerItem}>
            <MyTypography variant="subtitle3" className={classes.headerTitle}>
              {intl.formatMessage({
                defaultMessage: "เลขที่ PO ลูกค้า"
              })}
            </MyTypography>
            <MyTypography variant="body3">
              {previewOrder?.__typename === "PreviewOrderLines"
                ? previewOrder?.orderNo
                : previewOrder?.poNo}
            </MyTypography>
          </Box>
          <Box className={classes.headerItem}>
            <MyTypography variant="subtitle3" className={classes.headerTitle}>
              {intl.formatMessage({
                defaultMessage: "วันที่สร้างใบสั่งซื้อ"
              })}
            </MyTypography>
            <MyTypography variant="body3">
              {maybe(() =>
                formatDate(
                  previewOrder?.__typename === "PreviewDomesticOrderLines"
                    ? previewOrder?.poDate
                    : previewOrder.createdAt
                )
              )}
            </MyTypography>
          </Box>
          <Box className={classes.headerItem}>
            <MyTypography variant="subtitle3" className={classes.headerTitle}>
              {intl.formatMessage({
                defaultMessage: "เงื่อนไขการชำระเงิน"
              })}
            </MyTypography>
            <MyTypography variant="body3">
              {previewOrder?.__typename === "PreviewDomesticOrderLines"
                ? ` ${previewOrder?.paymentTermKey}- ${previewOrder?.paymentTermDescTh}`
                : previewOrder?.paymentTermDescriptionTh}
            </MyTypography>
          </Box>
        </Grid>
        <Grid item xs={12} md={9}>
          <Box className={classes.headerItem}>
            <MyTypography variant="subtitle3" className={classes.headerTitle}>
              {intl.formatMessage({
                defaultMessage: "เลขที่ Contract"
              })}
            </MyTypography>
            <MyTypography variant="body3">
              {`${previewOrder?.contract?.code} - ${previewOrder?.contract?.projectName}`}
            </MyTypography>
          </Box>
          <Box className={classes.headerItem}>
            <MyTypography variant="subtitle3" className={classes.headerTitle}>
              {intl.formatMessage({
                defaultMessage: "ชื่อลูกค้า"
              })}
            </MyTypography>
            <MyTypography
              variant="body3"
              style={{
                whiteSpace: "pre-line"
              }}
            >
              {previewOrder?.__typename === "PreviewOrderLines"
                ? `${previewOrder?.customerSoldToOrder}\n${previewOrder?.soldToAddress}`
                : `${previewOrder?.soldTo.soldToCode} - ${previewOrder?.soldTo.soldToName}\n${previewOrder?.soldTo.addressText}`}
            </MyTypography>
          </Box>
          <Box className={classes.headerItem}>
            <MyTypography variant="subtitle3" className={classes.headerTitle}>
              {intl.formatMessage({
                defaultMessage: "สถานที่จัดส่ง"
              })}
            </MyTypography>
            <MyTypography
              style={{
                whiteSpace: "pre-line"
              }}
              variant="body3"
            >
              {previewOrder?.shipTo}
            </MyTypography>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};
export default PreviewOrderHeader;
